import React, { useState, createContext } from 'react';

const context = {};

export const SideNavContext = createContext(context);

export const SideNavContextProvider = props => {
  const [sideNavToggle, setSideNavToggle] = useState(false);

  const toggleSideNav = React.useCallback(() => {
    setSideNavToggle(prev => !prev);
  }, []);

  const contextValue = React.useMemo(() => ({
    sideNavState: sideNavToggle,
    toggleSideNav,
  }), [sideNavToggle, toggleSideNav]);

  return (
    <SideNavContext.Provider value={contextValue}>
      {props.children}
    </SideNavContext.Provider>
  );
};
